import styled from 'styled-components'
import { BackBtn } from '../buttons'

export const ProductWizardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 186px);
  grid-gap: 17px;

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(2, 124px);
    grid-gap: 8px;
  `}
`

export const ProductWizardCardItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.primary25};
  white-space: normal;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  word-break: break-word;

  &:hover {
    background-color: ${props => props.theme.color.primary100};
  }

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 80px;
  `}
`

export const StepWrapper = styled.div`
  width: 672px;
  min-height: 399px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${props => props.theme.media.mobile`
    width: auto;
  `}
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`

export const ProcoteCropContainer = styled.div`
  height: 325px;
  display: flex;
  justify-content: center;
  overflow-y: auto;

  ${props => props.theme.media.mobile`
    max-width: none;
  `}
`

export const SpinnerWrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BackButton = styled(BackBtn)`
  margin-bottom: 0px;
`
